import { ADD_BROKER_MESSAGE, ADD_BROKER_MESSAGE_ERROR, ADD_BROKER_MESSAGE_SUCCESS, GET_BROKER_MESSAGE, GET_BROKER_MESSAGE_FAIL, GET_BROKER_MESSAGE_SUCCESS } from "./actionTypes"

export const addBrokerMessage = (message, history, resetForm) => {
  return {
    type: ADD_BROKER_MESSAGE,
    payload: { message, history, resetForm },
  }
}

export const addBrokerMessageSuccess = event => {
  return {
    type: ADD_BROKER_MESSAGE_SUCCESS,
    payload: event,
  }
}


export const addBrokerMessageError = error => {
  return {
    type: ADD_BROKER_MESSAGE_ERROR,
    payload: error,
  }
}


export const getBrokerMessage = (BrokerId, agentId) => ({
  type: GET_BROKER_MESSAGE,
  payload: { BrokerId, agentId },
})

export const getBrokerMessageSuccess = (messages, agentId) => ({
  type: GET_BROKER_MESSAGE_SUCCESS,
  payload: messages,
  agentId,
})

export const getBrokerMessageFail = error => ({
  type: GET_BROKER_MESSAGE_FAIL,
  payload: error,
})
